import { render, staticRenderFns } from "./SelectDeliveryMethod.vue?vue&type=template&id=603e09a8"
import script from "./SelectDeliveryMethod.vue?vue&type=script&lang=js"
export * from "./SelectDeliveryMethod.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports